export default {
  path: '/title-lists/:id',
  name: 'title-list',
  props: true,
  component: () => import(/* webpackChunkName: "title-list-show" */ './TitleList'),
  meta: {
    requiresAuth: true
  }
}
